import { INTRODUCTION, NONE, NEXT_STEPS, BUDGET } from '../../constants/CallTopics';
export const mockUtterances = [{
  id: '1-4.1-4.7',
  utterance: 'head over there',
  speakerTrackId: 1,
  startTimeSeconds: 4.1,
  endTimeSeconds: 4.7,
  callTopicTags: [{
    name: INTRODUCTION,
    prediction: 1
  }]
}, {
  id: '1-11.1-13.3',
  utterance: ' Hello, there should be recording now.',
  speakerTrackId: 1,
  startTimeSeconds: 11.1,
  endTimeSeconds: 13.3,
  callTopicTags: [{
    name: NONE,
    prediction: 1
  }]
}, {
  id: '1-16.5-19.8',
  utterance: ' Do you want to set up a meeting for next Tuesday?',
  speakerTrackId: 1,
  startTimeSeconds: 16.5,
  endTimeSeconds: 19.8,
  callTopicTags: [{
    name: NEXT_STEPS,
    prediction: 1
  }]
}, {
  id: '1-21.5-27.2',
  utterance: ' Do you want to arrange a call for the next week?',
  speakerTrackId: 1,
  startTimeSeconds: 21.5,
  endTimeSeconds: 27.2,
  callTopicTags: [{
    name: NEXT_STEPS,
    prediction: 1
  }]
}, {
  id: '1-28.1-30',
  utterance: ' Maybe we can organize something.',
  speakerTrackId: 1,
  startTimeSeconds: 28.1,
  endTimeSeconds: 30,
  callTopicTags: [{
    name: BUDGET,
    prediction: 1
  }]
}, {
  id: '1-32-33.6',
  utterance: " Okay, that's all right.",
  speakerTrackId: 1,
  startTimeSeconds: 32,
  endTimeSeconds: 33.6,
  callTopicTags: [{
    name: BUDGET,
    prediction: 1
  }]
}, {
  id: '1-37.4-40.2',
  utterance: " Okay, let's confirm this for the next week.",
  speakerTrackId: 1,
  startTimeSeconds: 37.4,
  endTimeSeconds: 40.2,
  callTopicTags: [{
    name: BUDGET,
    prediction: 1
  }]
}, {
  id: '1-42-43.8',
  utterance: " It's have a call next month.",
  speakerTrackId: 1,
  startTimeSeconds: 42,
  endTimeSeconds: 43.8,
  callTopicTags: [{
    name: NEXT_STEPS,
    prediction: 1
  }]
}, {
  id: '1-45.9-47.2',
  utterance: ' Thank you very much, bye-bye.',
  speakerTrackId: 1,
  startTimeSeconds: 45.9,
  endTimeSeconds: 47.2,
  callTopicTags: [{
    name: BUDGET,
    prediction: 1
  }]
}];
export const mockTimelineUtterances = [{
  utterance: 'head over there',
  startTimeSeconds: 4.1,
  endTimeSeconds: 4.7,
  callTopics: [{
    name: INTRODUCTION,
    prediction: 1
  }]
}, {
  utterance: ' Hello, there should be recording now.',
  startTimeSeconds: 11.1,
  endTimeSeconds: 13.3,
  callTopics: [{
    name: NONE,
    prediction: 1
  }]
}, {
  utterance: ' Do you want to set up a meeting for next Tuesday?',
  startTimeSeconds: 16.5,
  endTimeSeconds: 19.8,
  callTopics: [{
    name: NEXT_STEPS,
    prediction: 1
  }]
}, {
  utterance: ' Do you want to arrange a call for the next week?',
  startTimeSeconds: 21.5,
  endTimeSeconds: 27.2,
  callTopics: [{
    name: NEXT_STEPS,
    prediction: 1
  }]
}, {
  utterance: ' Maybe we can organize something.',
  startTimeSeconds: 28.1,
  endTimeSeconds: 30,
  callTopics: [{
    name: BUDGET,
    prediction: 1
  }]
}, {
  utterance: " Okay, that's all right.",
  startTimeSeconds: 32,
  endTimeSeconds: 33.6,
  callTopics: [{
    name: BUDGET,
    prediction: 1
  }]
}, {
  utterance: " Okay, let's confirm this for the next week.",
  startTimeSeconds: 37.4,
  endTimeSeconds: 40.2,
  callTopics: [{
    name: BUDGET,
    prediction: 1
  }]
}, {
  utterance: " It's have a call next month.",
  startTimeSeconds: 42,
  endTimeSeconds: 43.8,
  callTopics: [{
    name: NEXT_STEPS,
    prediction: 1
  }]
}, {
  utterance: ' Thank you very much, bye-bye.',
  startTimeSeconds: 45.9,
  endTimeSeconds: 47.2,
  callTopics: [{
    name: BUDGET,
    prediction: 1
  }]
}];
export const mockUtteranceDataForPQL = [{
  id: '-1-4.1-4.7',
  utterance: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad',
  speakerTrackId: -1,
  startTimeSeconds: 4.1,
  endTimeSeconds: 4.7,
  callTopicTags: []
}, {
  id: '-2-11.1-13.3',
  utterance: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad',
  speakerTrackId: -2,
  startTimeSeconds: 11.1,
  endTimeSeconds: 13.3,
  callTopicTags: []
}, {
  id: '-1-16.5-19.8',
  utterance: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad',
  speakerTrackId: -1,
  startTimeSeconds: 16.5,
  endTimeSeconds: 19.8,
  callTopicTags: []
}, {
  id: '-2-21.5-27.2',
  utterance: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad',
  speakerTrackId: -2,
  startTimeSeconds: 21.5,
  endTimeSeconds: 27.2,
  callTopicTags: []
}];